import { User } from '@vex/model/user';
import { Injectable } from '@angular/core';
import { BaseService, IPaginatorService } from './base';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BasePaginator } from '../model/base/base-model';

export interface LoginActiveDirectoryOption {
  ActiveDirectoryId: string;
  Name: string;
  TenantId: string;
  // App registration (public client id) for this connector; authority is /{TenantId}.
  ClientId?: string;
  PrimaryDomain: string;
  // Populated for the flat deployment-directory listing (GET Account/Directories).
  OrganizationId?: string;
  OrganizationName?: string;
}

export interface LoginOrganizationOption {
  OrganizationId: string;
  OrganizationName: string;
  IsPrimary: boolean;
  SupportsLocalLogin: boolean;
  ActiveDirectories: LoginActiveDirectoryOption[];
}

export interface LoginDiscoveryResponse {
  UserFound: boolean;
  RequiresOrganizationSelection: boolean;
  Organizations: LoginOrganizationOption[];
}

@Injectable({
  providedIn: 'root'
})
export class AccountService extends BaseService {

  readonly baseEndpoint = 'Account';

  constructor(private http: HttpClient) {
    super();
  }

  ChangeNdaStatus(params: any): Observable<any> {
    let url = this.baseUrl + this.baseEndpoint + '/ChaneNdaStatus';
    return this.http.post<any>(url, params);
  }

  getMyOrganizations(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + this.baseEndpoint + '/GetMyOrganizations');
  }

  switchOrganization(organizationId: string): Observable<any> {
    return this.http.post<any>(this.baseUrl + this.baseEndpoint + '/SwitchOrganization/' + organizationId, {});
  }

  discoverLoginOptions(email: string): Observable<LoginDiscoveryResponse> {
    return this.http.post<LoginDiscoveryResponse>(
      this.baseUrl + this.baseEndpoint + '/DiscoverLoginOptions',
      { Email: email }
    );
  }

  // Connected Entra connectors for this deployment (public client ids only). Drives the
  // no-email "Sign in with Microsoft" entry point on the login page.
  getLoginDirectories(): Observable<LoginActiveDirectoryOption[]> {
    return this.http.get<LoginActiveDirectoryOption[]>(
      this.baseUrl + this.baseEndpoint + '/Directories'
    );
  }

  // After a Microsoft popup sign-in, resolve every org this Entra identity can enter in that
  // tenant. One -> sign in directly; several -> show an org picker.
  resolveDirectoryLogin(accessToken: string, activeDirectoryId: string): Observable<LoginDiscoveryResponse> {
    return this.http.post<LoginDiscoveryResponse>(
      this.baseUrl + this.baseEndpoint + '/ResolveDirectoryLogin',
      { AccessToken: accessToken, ActiveDirectoryId: activeDirectoryId }
    );
  }
}
